import React from 'react';

import type { LayoutApp, LayoutWidgetElement } from '@typings/layout.ts';

import { widgetEnum } from './constants.ts';

const findByLayoutId = (layoutId: string, children: React.ReactNode, app?: LayoutApp): LayoutWidgetElement[] => {
  const isDesktop = app?.env?.isDesktop?.() ?? false;
  const isMobile = app?.env?.isMobile?.() ?? false;

  const childList = (Array.isArray(children) ? children : [children]).filter(
    React.isValidElement,
  ) as LayoutWidgetElement[];

  return childList.filter(
    c => ((isDesktop && isDesktopWidget(c)) || (isMobile && isMobileWidget(c))) && c?.props?.layoutId === layoutId,
  );
};

const isDesktopWidget = (el: LayoutWidgetElement): boolean => {
  const widgetType = el?.props?.widgetType;
  // if widgetType is undefined, then assume component can show for both desktop and mobile
  if (widgetType === widgetEnum.Desktop || !widgetType) {
    return true;
  }
  return false;
};

const isMobileWidget = (el: LayoutWidgetElement): boolean => {
  const widgetType = el?.props?.widgetType;
  if (widgetType === widgetEnum.Mobile || !widgetType) {
    return true;
  }
  return false;
};

export default findByLayoutId;
